import { tv } from 'tailwind-variants';

export { default as DropdownMenu } from './DropdownMenu.vue';
export { default as RowActionsDropdown } from './RowActionsDropdown.vue';

export const dropdownMenuVariants = tv({
    slots: {
        content: [
            'z-dropdown min-w-44 overflow-hidden rounded-md border border-gray-300 bg-white p-1 shadow-lg',
            'focus:outline-hidden',
            'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
            'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
        ],
        item: [
            'flex w-full cursor-pointer select-none items-center gap-x-2 whitespace-nowrap rounded-md px-2 py-1.5 text-left text-sm text-gray-900 outline-none transition-colors duration-100',
            'data-[highlighted]:bg-gray-100',
            'data-[variant=destructive]:text-red-600 data-[variant=destructive]:data-[highlighted]:bg-red-600/10',
        ],
        separator: 'my-1 h-px bg-gray-100',
        label: 'px-2 py-2 text-left',
    },
    variants: {
        variant: {
            default: {},
            destructive: {},
        },
        disabled: {
            true: { item: 'cursor-not-allowed opacity-50 data-[highlighted]:bg-transparent' },
        },
    },
    defaultVariants: { variant: 'default', disabled: false },
});
